module.exports = require("react-tether");


/*****************
 ** WEBPACK FOOTER
 ** external "react-tether"
 ** module id = 41
 ** module chunks = 0
 **/